import React, { useState } from "react";
import { toast } from 'react-toastify';
import { createNote } from "../api/candidiate";
import { useSelector } from "react-redux";
import Loader from "./Loader";

const NewNote = ({ noteType = 'Candidate', fetchData = null }) => {
  const [isLoading, setLoading] = useState(false);
  const candidateId = useSelector(state => state.personal.candidateId);
  const userInfo = useSelector(state => state.user.userInfo);
  const userName = userInfo?.user_name || userInfo?.email || 'User';
  const [content, setContent] = useState("");

  const handleSubmit = async () => {
    if (!content.trim()) {
      toast.warning('Please enter a note before saving');
      return;
    }
    if (!candidateId) {
      toast.error('No candidate selected. Please save candidate first.');
      return;
    }
    if (content.length > 2000) {
      toast.warning('Note cannot exceed 2000 characters');
      return;
    }
    setLoading(true);
    try {
      await createNote(content, candidateId, noteType);
      setContent("");
      if (fetchData) await fetchData();
      toast.success('Note added successfully');
    } catch (err) {
      console.error(err);
      const status = err?.response?.status;
      const data = err?.response?.data;
      if (status === 400) {
        toast.error(data?.details || data?.message || 'Invalid note data');
      } else if (status === 401) {
        toast.error('Unauthorized: Please log in again.');
      } else {
        toast.error(data?.message || 'Failed to add note. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full border border-zinc-100 flex-col justify-start items-start inline-flex">
      {isLoading && <Loader />}
      <div className="flex justify-between items-center border-b border-zinc-100 w-full p-3 text-xs text-text-hint">
        <div className="flex items-center gap-2">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="icon">
              <path
                id="Vector 9"
                d="M5.33545 1.87048L11.3354 7.87048L5.33545 13.8705"
                stroke="#00ABB6"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
          </svg>
          <span className="font-normal text-black text-xs">New Note</span>
          <p>By {userName}</p>
        </div>
        <div className="flex gap-2">
          <button
            onClick={handleSubmit}
            disabled={isLoading || !content.trim()}
            className={`text-xs py-2 px-5 rounded-full ${content.trim() ? 'bg-secondary-700 text-white' : 'bg-neutral-200 text-gray-400 cursor-not-allowed'}`}
          >
            Save
          </button>
        </div>
      </div>

      <div className="flex px-6 w-full h-auto">
        <textarea
          onChange={(e) => setContent(e.target.value)}
          value={content}
          placeholder="Type your note here..."
          className="w-full focus:ring-0 border-none outline-none text-xs"
          rows={3}
        ></textarea>
      </div>
    </div>
  );
};

export default NewNote;
